
      import { getAllSchemas } from './src/schemas/index.ts';
      document.getElementById('schema-markup').textContent = JSON.stringify(getAllSchemas());
    